import { StatusBar } from "expo-status-bar";
import React from "react";
import {
  Keyboard,
  KeyboardAvoidingView,
  Platform,
  StyleSheet,
} from "react-native";
import {
  ScrollView,
  TouchableWithoutFeedback,
} from "react-native-gesture-handler";
import { SafeAreaView } from "react-native-safe-area-context";

const KeyBoardAvoidingWrapper = ({ children }) => {
  return (
    <SafeAreaView style={{ flex: 1, backgroundColor: "#A48578" }}>
      <KeyboardAvoidingView
        style={{ flex: 1 }}
        behavior={Platform.OS === "ios" ? "padding" : "height"}
      >
        {Platform.OS != "web" ? (
          <ScrollView
            showsVerticalScrollIndicator={false}
            keyboardDismissMode={"on-drag"}
            bounces={false}
            contentContainerStyle={styles.contentContainer}
          >
            {children}
          </ScrollView>
        ) : (
          children
        )}
      </KeyboardAvoidingView>
    </SafeAreaView>
  );
};

const styles = StyleSheet.create({
  contentContainer: {
    paddingTop: Platform.OS == "android" ? StatusBar.currentHeight : 0,
  },
});
export default KeyBoardAvoidingWrapper;
